<template>
  <VSlider v-model="sliderValue" :min="0" :max="10" :step="1" :with-ticks="true" :class="[theme]">
    <template #ticks>
      <div
        class="labels"
        :style="{
          '--size': tickSize,
        }"
      >
        <button v-for="option in sliderOptions" :key="option" class="appearance-none" @click="setRadius(option)">
          {{ prefix }}{{ option }}
        </button>
      </div>
    </template>
  </VSlider>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'

type TickSize = 'xs'

const props = defineProps({
  size: {
    type: String as PropType<TickSize>,
    default: 'xs',
  },
  defaultRadius: {
    type: Number,
    default: 5,
  },
  theme: {
    type: String as PropType<'light' | 'dark'>,
    default: 'light',
  },
  prefix: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['set-radius'])
const tickSizes = {
  xs: '0.5rem',
}
const sliderValue = ref(0)
const sliderOptions = [0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

const tickSize = computed(() => tickSizes[props.size as TickSize] || tickSizes.xs)
const computedSliderValue = computed(() => (sliderOptions[sliderValue.value] === 0 ? 0.5 : sliderOptions[sliderValue.value]))

watch(computedSliderValue, value => {
  emit('set-radius', value)
})

onMounted(() => {
  setRadius(props.defaultRadius)
})

function setRadius(value: number) {
  sliderValue.value = sliderOptions.indexOf(value)
}
</script>

<style lang="stylus" scoped>
.labels
  display flex
  justify-content space-between
  margin-top 16px
  width 100%

  button
    text-align center
    position relative
    font-size var(--size)

    &:first-child::before
      left 5px

    &::before
      content ''
      position absolute
      top -8px
      left 50%
      transform translateX(-50%)
      width 1px
      height 4px
      background-color #fff
      border-radius 1px

.dark
  .labels
    button
      @apply text-gray-800
      &::before
        @apply bg-gray-800
</style>
